import RemoveUser from './RemoveUser'

export default RemoveUser
// eslint-disable-next-line import/export
export * from './RemoveUser'
